import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { getVariantPath } from '@uswitch/spark.utils';
import PropTypes from 'prop-types';
import React from 'react';
import { PaginationArrow } from './arrow';
import { PaginationContextProvider } from './context';
import { Pages } from './pages';
import { jsx as _jsx } from "theme-ui/jsx-runtime";
import { jsxs as _jsxs } from "theme-ui/jsx-runtime";
var variantPath = getVariantPath({
  id: 'pagination'
});
export var Pagination = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var totalPages = _ref.totalPages,
      currentPage = _ref.currentPage,
      createPageUrl = _ref.createPageUrl,
      _ref$showFirstAndLast = _ref.showFirstAndLastArrows,
      showFirstAndLastArrows = _ref$showFirstAndLast === void 0 ? true : _ref$showFirstAndLast,
      _ref$maximumPageNumbe = _ref.maximumPageNumbersToDisplay,
      maximumPageNumbersToDisplay = _ref$maximumPageNumbe === void 0 ? 8 : _ref$maximumPageNumbe,
      children = _ref.children,
      props = _objectWithoutProperties(_ref, ["totalPages", "currentPage", "createPageUrl", "showFirstAndLastArrows", "maximumPageNumbersToDisplay", "children"]);

  var isFirstPage = currentPage === 1;
  var isLastPage = currentPage === totalPages;
  return _jsx("nav", _objectSpread(_objectSpread({
    ref: ref,
    sx: {
      variant: variantPath()
    }
  }, props), {}, {
    children: _jsxs(PaginationContextProvider, {
      currentPage: currentPage,
      totalPages: totalPages,
      createPageUrl: createPageUrl,
      maximumPageNumbersToDisplay: maximumPageNumbersToDisplay,
      showFirstAndLastArrows: showFirstAndLastArrows,
      children: [showFirstAndLastArrows && _jsx(PaginationArrow, {
        variant: "first",
        disabled: isFirstPage
      }), _jsx(PaginationArrow, {
        variant: "previous",
        disabled: isFirstPage
      }), _jsx(Pages, {}), _jsx(PaginationArrow, {
        variant: "next",
        disabled: isLastPage
      }), showFirstAndLastArrows && _jsx(PaginationArrow, {
        variant: "last",
        disabled: isLastPage
      })]
    })
  }));
});
Pagination.propTypes = {
  /**
   * Total number of pages
   */
  totalPages: PropTypes.number,

  /**
   * Current active page
   */
  currentPage: PropTypes.number,

  /**
   * Function to build target href. Is given the page number as an argument depending on the arrow or number clicked
   */
  createPageUrl: PropTypes.func,

  /**
   * Whether to display the first and last arrows
   */
  showFirstAndLastArrows: PropTypes.bool
};
Pagination.defaultProps = {
  totalPages: 0,
  currentPage: 0
};
Pagination.displayName = 'Pagination';